module.exports = __webpack_public_path__ + "img/KI.c741fddf.png";